export default {
    YES: 'Yes',
    NO: 'No',
};
